import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { Control } from 'react-hook-form';

import Label from '~components/FormFields/v2/Label';
import TextInput from '~components/FormFields/v2/TextInput';

import { EM_DASH, SETTLEMENT_NOTES_MAX_LENGTH } from '../SettlementDetails/constants';
import { settlementSheetCardSx } from './settlementSheetDisplay';
import { SettlementSheetFormValues } from './settlementSheetForm';

interface SettlementSheetNotesProps {
  control: Control<SettlementSheetFormValues>;
  isEditing: boolean;
  notes: string | null;
}

export default function SettlementSheetNotes({
  control,
  isEditing,
  notes,
}: SettlementSheetNotesProps) {
  return (
    <Box
      sx={(theme) => ({
        ...settlementSheetCardSx(theme),
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        minWidth: '300px',
      })}
    >
      <Label>{t('form_fields.notes')}</Label>
      {isEditing ? (
        <TextInput
          control={control}
          name="notes"
          placeholder={t('approvals.driver_pay.settlements.sheet.notes_placeholder')}
          rows={3}
          rules={{
            maxLength: {
              message: t('form_validation_errors.max_length', {
                field: t('form_fields.notes'),
                max: SETTLEMENT_NOTES_MAX_LENGTH,
              }),
              value: SETTLEMENT_NOTES_MAX_LENGTH,
            },
          }}
        />
      ) : (
        <Typography variant="body2">{notes || EM_DASH}</Typography>
      )}
    </Box>
  );
}
